import { render, staticRenderFns } from "./ModalDetailIndication.vue?vue&type=template&id=48822bd4&scoped=true"
import script from "./ModalDetailIndication.vue?vue&type=script&lang=js"
export * from "./ModalDetailIndication.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailIndication.vue?vue&type=style&index=0&id=48822bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48822bd4",
  null
  
)

export default component.exports